import { getRequest, postRequest } from "./api";
import store from "../redux/store";

export const checkChannelStatus = async (channelId, token) => {
  const { organizationId, accountId, workspaceId, agentId } = store.getState().info;

  const searchParams = new URLSearchParams();

  searchParams.set("channelId", channelId);
  searchParams.set("organizationId", organizationId);
  searchParams.set("accountId", accountId);
  searchParams.set("workspaceId", workspaceId);
  searchParams.set("agentId", agentId);

  const endpoint = `snippet/channel-status?${searchParams.toString()}`;
  const response = await getRequest({ endpoint, token });
  if (!response) {
    return null;
  }
  const data = await response.json();
  return data;
};

export const getWorkspaceInfo = async (
  organizationId,
  accountId,
  workspaceId,
  token,
  channelId,
  accountName,
  workspaceName,
  agentName,
  agentId,
  agentLanguage = "en-US"
) => {
  var endpoint = "snippet/info";
  endpoint += `?organizationId=${organizationId}`;
  endpoint += `&accountId=${accountId}`;
  endpoint += `&workspaceId=${workspaceId}`;
  endpoint += `&channelId=${channelId}`;

  endpoint += accountName ? `&accountName=${accountName}` : "";
  endpoint += workspaceName ? `&workspaceName=${workspaceName}` : "";
  endpoint += agentName ? `&agentName=${agentName}` : "";
  endpoint += agentId ? `&agentId=${agentId}` : "";
  endpoint += agentLanguage ? `&agentLanguage=${agentLanguage}` : "";

  const response = await getRequest({ endpoint, token });
  const workspaceInfo = await response.json();
  return workspaceInfo;
};

export const saveWorkspaceInfo = async (workspaceInfo, token) => {
  const endpoint = "mb/workspace";
  const response = await postRequest({ endpoint, token, data: workspaceInfo });
  // TODO: Handle error response
  if (!response.ok) {
    return { success: false, message: "An error occurred while saving the workspace. Please try again shortly." };
  }
  return { success: true, message: "Workspace info saved successfully" };
};
